import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { App, Button, Card, Space } from 'antd';
import { ApartmentOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import PageHeader from 'components/headings/PageHeader';
import ComponentTemplatesContent from 'pages/liftlogic/v2/Components/ComponentTemplatesContent';

function TenantComponentTemplatesPage() {
  const { tenantId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const tenantName = location.state?.tenantName || `Tenant ${tenantId}`;

  return (
    <App>
      <div style={{ padding: 16 }}>
        <PageHeader
          icon={ApartmentOutlined}
          title="Plantillas de componentes"
          subtitle={`Tenant: ${tenantName}`}
          actions={
            <Space>
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={() =>
                  navigate(`/admin/tenants/${tenantId}/edit`, { state: location.state })
                }
              >
                Volver al tenant
              </Button>
            </Space>
          }
        />
        <Card>
          <ComponentTemplatesContent />
        </Card>
      </div>
    </App>
  );
}

export default TenantComponentTemplatesPage;
